export enum PaymentMethod {
  TRF = 'TRF',
  DD = 'DD',
  CHK = 'CHK',
  TRA = 'TRA',
}
